<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <h4 class="page-title">Update Invoice</h4>
    </div>
  </div>
</div>
<app-invoice-form
  [form]="form"
  [buttonText]="buttonText"
  [errorProvider]="errorProvider"
  [submittingProvider]="submittingProvider"
  (clicked)="updateInvoice()"
></app-invoice-form>
